import React, { useCallback, useMemo } from 'react'
import classNames from 'classnames'
import conf from 'conf'
import settings from 'popups/Settings'
import styles from './style.module.scss'

export const isSafari =
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
  !/CriOS|FxiOS|OPiOS|mercury/i.test(navigator.userAgent)

// Firefox 데스크톱(`Firefox`) + iOS Firefox(`FxiOS`).
// Document-Isolation-Policy 미지원 → iframe 임베드 시 SAB/WASM threads가 동작하지 않으므로
// Safari와 동일하게 별도 top-level 창에서 열어 자체적으로 cross-origin isolated 상태가 되도록 한다.
export const isFirefox = /firefox|fxios/i.test(navigator.userAgent)

export const buildDocViewerUrl = (fileUrl: string, fileName: string, clientId?: string): string => {
  const params = new URLSearchParams()
  const hash = conf.gitInfo.commit.hash
  params.set('hash', hash)
  if (fileUrl != null) {
    params.set('fileUrl', fileUrl)
  }
  if (fileName != null) {
    params.set('fileName', fileName)
  }
  const { locale } = settings.getValue('general')
  if (locale != null) {
    params.set('locale', locale.substring(0, 2).toLowerCase())
  }
  if (clientId) {
    params.set('clientId', clientId)
  } else {
    params.set('clientId', import.meta.env.VITE_DOC_VIEWER_CLIENT_ID)
  }
  return `/doc-viewer/index.html?${params.toString()}`
}

interface DocViewerProps {
  fileUrl: string
  fileName: string
  clientId?: string
  className?: string
  style?: React.CSSProperties
}

const DocViewer: React.FC<DocViewerProps> = ({ fileUrl, fileName, clientId, className, style }) => {
  const src = useMemo(
    () => buildDocViewerUrl(fileUrl, fileName, clientId),
    [fileUrl, fileName, clientId],
  )

  const openInNewTab = useCallback(() => {
    window.open(src, '_blank')
  }, [src])

  if (isSafari || isFirefox) {
    return (
      <div className={classNames(styles.docViewer, className)} style={style}>
        <button className={styles.openButton} type="button" onClick={openInNewTab}>
          Open Document Viewer
        </button>
      </div>
    )
  }

  return (
    <div className={classNames(styles.docViewer, className)} style={style}>
      <iframe className={styles.iframe} src={src} title="Document Viewer" />
    </div>
  )
}

export default DocViewer
